import { render } from "./ManuscriptCoverModern.vue?vue&type=template&id=a4b48258"
import script from "./ManuscriptCoverModern.vue?vue&type=script&lang=js"
export * from "./ManuscriptCoverModern.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__